module.exports = function() {
  return new Worker(__webpack_public_path__ + "d563744a40f14c711af0.worker.js");
};